import React from "react";

// Source
import ControllerAuthentication from "../controller/Authentication";
import ViewLoader from "../view/Loader";

let isRendered = false;

const viewPageLogout: React.FC = () => {
    // Variable
    const controllerAuthentication = new ControllerAuthentication("logout", isRendered);

    // Method
    controllerAuthentication.initializeHook();

    // Render
    isRendered = true;

    return (
        <div className="view_logout">
            <ViewLoader />
        </div>
    );
};

export default viewPageLogout;
